<template>
    <svg id="design"  viewBox="0 0 184.61 187.91" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="a" x1="19.52" x2="175.41" y1="166.73" y2="10.85" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8bcdf5" offset="0"/>
                <stop stop-color="#8bcdf5" offset=".09"/>
                <stop stop-color="#8bcdf5" offset=".22"/>
                <stop stop-color="#8bcdf5" offset=".37"/>
                <stop stop-color="#8bcdf5" offset=".53"/>
                <stop stop-color="#9820EF" offset=".72"/>
                <stop stop-color="#9820EF" offset=".91"/>
                <stop stop-color="#9820EF" offset=".99"/>
            </linearGradient>
        </defs>
        <g data-name="Layer 2">
            <g data-name="Layer 2">
                <path class="cls-1" d="M150.6,52h31.15a2.86,2.86,0,0,0,2.86-2.85V2.85A2.86,2.86,0,0,0,181.75,0H150.6a2.86,2.86,0,0,0-2.85,2.85v20.3H111.36V2.85A2.86,2.86,0,0,0,108.51,0H77.35A2.86,2.86,0,0,0,74.5,2.85v20.3H36.86V2.85A2.86,2.86,0,0,0,34,0H2.85A2.86,2.86,0,0,0,0,2.85V49.16A2.86,2.86,0,0,0,2.85,52H34a2.86,2.86,0,0,0,2.86-2.85V28.86H53V74.55A23.42,23.42,0,0,0,74.5,97.87v20.38a2.86,2.86,0,0,0,2.85,2.85h31.16a2.86,2.86,0,0,0,2.85-2.85V71.94a2.86,2.86,0,0,0-2.85-2.85H77.35a2.86,2.86,0,0,0-2.85,2.85v20.2A17.71,17.71,0,0,1,58.65,74.55V28.86H74.5v20.3A2.86,2.86,0,0,0,77.35,52h31.16a2.86,2.86,0,0,0,2.85-2.85V28.86h15.85v112.5a23.42,23.42,0,0,0,20.54,23.21v20.49a2.86,2.86,0,0,0,2.85,2.85h31.15a2.86,2.86,0,0,0,2.86-2.85V138.75a2.85,2.85,0,0,0-2.86-2.85H150.6a2.85,2.85,0,0,0-2.85,2.85V158.8a17.71,17.71,0,0,1-14.84-17.44V89.84a23.4,23.4,0,0,0,14.84,7.93v20.48a2.86,2.86,0,0,0,2.85,2.85h31.15a2.86,2.86,0,0,0,2.86-2.85V71.94a2.86,2.86,0,0,0-2.86-2.85H150.6a2.86,2.86,0,0,0-2.85,2.85V92a17.71,17.71,0,0,1-14.84-17.44V28.86h14.84v20.3A2.86,2.86,0,0,0,150.6,52ZM31.15,46.31H5.71V5.71H31.15ZM80.21,74.79h25.44v40.6H80.21Zm25.44-28.48H80.21V5.71h25.44Zm47.81,95.29H178.9v40.6H153.46Zm0-66.81H178.9v40.6H153.46Zm0-69.08H178.9v40.6H153.46Z"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "svg_design"
    }
</script>

<style scoped lang="scss">
    #design{
        width: 100px ;
        height:65px;
        float: left;
        .cls-1{fill:url(#a);}
    }
</style>